import { useState, useEffect } from 'react';

var thepeerJS = 'https://cdn.thepeer.co/v1/chain.js';
function useScript() {
  var _useState = useState({
    loaded: false,
    error: false
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    var scriptTag = document.getElementById('thepeer_script');
    var scriptSrc = scriptTag && scriptTag.getAttribute('src');
    if (scriptSrc) return setState({
      loaded: true,
      error: false
    });
    var script = document.createElement('script');
    script.id = 'thepeer_script';
    script.src = thepeerJS;
    script.async = true;

    var onScriptLoad = function onScriptLoad() {
      setState({
        loaded: true,
        error: false
      });
    };

    var onScriptError = function onScriptError() {
      setState({
        loaded: true,
        error: true
      });
    };

    script.addEventListener('load', onScriptLoad);
    script.addEventListener('complete', onScriptLoad);
    script.addEventListener('error', onScriptError);
    document.body.appendChild(script);
    return function () {
      script.removeEventListener('load', onScriptLoad);
      script.removeEventListener('complete', onScriptLoad);
      script.removeEventListener('error', onScriptError);
    };
  }, []);
  return [state.loaded, state.error];
}

var useDirectCharge = function useDirectCharge(props) {
  var _useScript = useScript(),
      loaded = _useScript[0],
      error = _useScript[1];

  useEffect(function () {
    if (error) throw new Error('Unable to load thepeer direct charge modal');
  }, [error]);
  return function () {
    if (error) throw new Error('Unable to load thepeer direct charge modal');

    if (loaded) {
      var directCharge = window.ThePeer && window.ThePeer.directCharge(props);
      directCharge.setup();
      return directCharge.open();
    }
  };
};

var useSend = function useSend(props) {
  var _useScript = useScript(),
      loaded = _useScript[0],
      error = _useScript[1];

  useEffect(function () {
    if (error) throw new Error('Unable to load thepeer send modal');
  }, [error]);
  return function () {
    if (error) throw new Error('Unable to load thepeer send modal');

    if (loaded) {
      var send = window.ThePeer && window.ThePeer.send(props);
      send.setup();
      return send.open();
    }
  };
};

var useCheckout = function useCheckout(props) {
  var _useScript = useScript(),
      loaded = _useScript[0],
      error = _useScript[1];

  useEffect(function () {
    if (error) throw new Error('Unable to load thepeer checkout modal');
  }, [error]);
  return function () {
    if (error) throw new Error('Unable to load thepeer checkout modal');

    if (loaded) {
      var checkout = window.ThePeer && window.ThePeer.checkout(props);
      checkout.setup();
      return checkout.open();
    }
  };
};

export { useCheckout, useDirectCharge, useSend };
//# sourceMappingURL=index.modern.js.map
